import React, { Component, Fragment } from "react";
import {
  Grid,
  withStyles,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  Chip,
  Backdrop, FormControl, Select, MenuItem, Button,
  CardHeader,
  IconButton,
  Link
} from "@material-ui/core";
import { useStyles } from "../../components/common/useStyles";
import "../../components/common/Common.css";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import DefaultCoverPic from "../../components/images/CoverPic.jpg";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { connect } from "react-redux";
import api from "../../components/common/APIValues";
import colorJsonData from "../json/CommunityColorTheme.json";
import EDWhatLogoIcon from "../../components/images/EdWhat-01-01.png";
import SuccessInfo from "../modal/SuccessInfo";
import QuestionIcon from "../../components/images/Question.png";
import ReactHtmlParser from "react-html-parser";
import routeService from "../../services/Routing";
import constant from "../../components/common/Constants";
import CommonFunc from "../../components/common/CommonFunc";
import CommunityNavMenu from "../users/CommunityNavMenu";
import { update, get } from "../../services/ApiService";
import imageSizes from "../json/ImageSize.json";
import MemberIcon from "../../components/images/Member.png";
import RequestedIcon from "../../components/images/Requested.png";
import DeniedIcon from "../../components/images/Denied.png";
import AcceptedIcon from "../../components/images/Accepted.png";
import JoinIcon from "../../components/images/Join.png";
import OwnerIcon from "../../components/images/Owner.png";

const withMediaQuery =
  (...args) =>
  (Component) =>
  (props) => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
  };

class CommunityAssignments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupId: 0,
      community: {},
      communityAssignments: [],
      loader: false,
      openInfo: false,
      textMsg: "",
      colorData: {},
      sortBy: 1,
      htmlUserToAdmin: "",
      htmlUserToUser: "",
      permissionLevel: "",
      err_msg: ""
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    let groupId = Number(this.props.match.params.groupId);
    this.setState({groupId: groupId});
    this.loadCommunity(groupId);
    this.validateUserPermission(groupId);
    this.getDefaultCommunityDetails(groupId);
  }

  validateUserPermission = (groupId) => {
    const originName = window.location.origin.replace("www.", "");
    const permissionName = "Create Topic";
    const inputs = `Env=${api.env}&GroupId=${groupId}&UserId=${this.props.userEmail}&PermissionName=${permissionName}&originName=${originName}`;
    get("Permission/ValidateUserPermission?" + inputs)
      .then((response) => {
        this.setState({ permissionLevel: response.PermissionName });
      })
      .catch(function (response) {
        this.setState({ err_msg: response, loader: false });
      });
  };

  isPdfFile(fileName) {
    if (fileName) {
        const parts = fileName.split('.');
        return parts.length > 1 && parts.pop().toLowerCase() === 'pdf';
    }
    else
        return false;
  }

  viewAssignmentDetails = (assignmentId, assignmentTitle) => {
    let pathName = constant.assignmentDetails + assignmentId;
    routeService.routePage(this.props, pathName);
  };

  getHtmlText = (s3BaseUrl) => {
    const htmlUserToAdminUrl = `${s3BaseUrl}/email-template/UserToAdminOnJoin.txt`;
    const htmlUserToUserUrl = `${s3BaseUrl}/email-template/UserToUserOnJoin.txt`;

    fetch(htmlUserToAdminUrl)
      .then((r) => r.text())
      .then((text) => {
        this.setState({ htmlUserToAdmin: text });
      });

    fetch(htmlUserToUserUrl)
      .then((r) => r.text())
      .then((text) => {
        this.setState({ htmlUserToUser: text });
      });
  };

  loadCommunityAssignments = (groupId, sortBy) => {
    const originName = window.location.origin.replace("www.", "");
    this.setState({ loader: true });
    let url = api.partialURL +
      "Community/GetCommunityAssignments?GroupId=" + groupId +
      "&UserId=" + this.props.userEmail +
      "&Env=" + api.env +
      "&SortInd=" + sortBy +
      "&originName=" + originName;
    let params = {
      UserId: this.props.userEmail,
      GroupId: groupId,
      SortInd: sortBy
    };
    this.fetchCommunityAssignments(url, params);
  };

  fetchCommunityAssignments = (url, params) => {
    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        let assignmentDetails = result.userAssignments;
        assignmentDetails.forEach((assignment, index) => {
          let desc = assignment.ASSIGNMENT_DESC;
          let mediaLink = desc.slice(
            desc.indexOf('<oembed url="') + 13,
            desc.lastIndexOf('"></oembed>')
          );

          if (
            mediaLink.includes("https://youtube.com/") ||
            mediaLink.includes("https://youtu.be/") ||
            mediaLink.includes("https://www.youtube.com/") ||
            mediaLink.includes("https://www.youtu.be/")
          ) {
            let videoId = CommonFunc.getYoutubeId(mediaLink);
            let iframeMarkup =
              '<iframe frameborder="0" style="width:560px;height:315px;" src="https://www.youtube.com/embed/' + videoId + '" allowfullscreen></iframe>';
            let oembedMarkup =
              '<figure class="media"><oembed url="' + mediaLink + '"></oembed></figure>';

            assignmentDetails[index].ASSIGNMENT_DESC = desc.replace(
              oembedMarkup,
              iframeMarkup
            );
          }
        });

        this.setCommunityAssignments(url, params, assignmentDetails);
      })
      .catch((err) => console.log(err));
  };

  setCommunityAssignments = (url, params, communityAssignments) => {
    this.setState({
      communityAssignments: communityAssignments,
      loader: false,
    });
  };

  getDefaultCommunityDetails = (groupId) => {
    this.setState({ loader: true });
    const originName = window.location.origin.replace("www.", "");
    const inputs = `env=${api.env}&originName=${originName}`;
    get("Home/GetDefaultCommunityDetails?" + inputs).then((response) => {
      this.setState({
        defaultCommunity: response,
        loader: false,
      });

      fetch(response.S3ConfigUrl)
        .then((r) => r.json())
        .then((jsonData) => {
          const websiteId = jsonData.websiteId;
          this.setState({ websiteId: websiteId });
          this.loadCommunityAssignments(
            groupId,
            Number(this.state.sortBy)
          );
        });

      const s3BaseUrl = response.S3ConfigUrl.replace(
        "/configuration/config.json",
        ""
      );
      this.getHtmlText(s3BaseUrl);
    });
  };

  loadCommunity = (groupId) => {
    const originName = window.location.origin.replace('www.', '');
    this.setState({ loader: true });
    fetch(
      api.partialURL + "Community/GetCommunity?GroupId=" + groupId +
        "&UserId=" + this.props.userEmail +
        "&ENV=" + api.env +
        '&originName=' + originName
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({ community: result, loader: false });
        let colorData = {};
        colorJsonData.map((color) => {
          if (color.name === result.ColorThemeName) {
            colorData.title = color.title;
            colorData.subtitle = color.subtitle;
            colorData.desc = color.desc;
          }
        });
      })
      .catch((err) => console.log(err));
  };

  onApplyColorTheme = (colorData) => {
    let groupId = this.props.match.params.groupId;
    this.setState({ colorData: colorData });
    let rowData = {
      ColorThemeName: colorData.name,
      Env: api.env,
      UpdatedUserId: this.props.userEmail,
    };

    update("CommunitySettings/UpdateColorTheme", rowData, groupId)
      .then((response) => {})
      .catch(function (response) {
        this.setState({ err_msg: response, loader: false });
      });
  };

  onEditGroupName = (new_title) => {
    let comm = this.state.community;
    comm.GroupName = new_title;
    this.setState({community: comm});
    let rowData = {
      GroupName: new_title,
      Env: api.env,
      UpdatedUserId: this.props.userEmail,
    };

    update("CommunitySettings/EditCommunityTitle", rowData, this.state.groupId)
      .then((response) => {})
      .catch(function (response) {
        console.log("ERROR: ", response);
      });
  };

  onEditGroupDesc = (new_desc) => {
    let comm = this.state.community;
    comm.GroupDesc = new_desc;
    this.setState({community: comm});
    let rowData = {
      GroupDesc: new_desc,
      Env: api.env,
      UpdatedUserId: this.props.userEmail,
    };

    update("CommunitySettings/EditCommunityDesc", rowData, this.state.groupId)
      .then((response) => {})
      .catch(function (response) {
        console.log("ERROR: ", response);
      });
  };

  handleFileSave = (type, imageUrl) => {
    let community = this.state.community;
    if (type === "cover_pic") {
      community.CoverUrl = imageUrl;
      this.updateCoverPic(imageUrl);
    } else {
      community.LogoUrl = imageUrl;
      this.updateLogoIcon(imageUrl);
    }
    this.setState({ community: community });
  };

  updateCoverPic = (coverUrl) => {
    let groupId = this.props.match.params.groupId;
    let rowData = {
      CoverUrl: coverUrl,
      Env: api.env,
      UpdatedUserId: this.props.userEmail,
    };

    update("CommunitySettings/UpdateCoverPic", rowData, groupId)
      .then((response) => {})
      .catch(function (response) {
        this.setState({ err_msg: response, loader: false });
      });
  };

  updateLogoIcon = (logoUrl) => {
    let groupId = this.props.match.params.groupId;
    let rowData = {
      LogoUrl: logoUrl,
      Env: api.env,
      UpdatedUserId: this.props.userEmail,
    };

    update("CommunitySettings/UpdateLogoIcon", rowData, groupId)
      .then((response) => {})
      .catch(function (response) {
        this.setState({ err_msg: response, loader: false });
      });
  };

  handleClose = () => {
    this.setState({ openInfo: false });
  };

  redirectToAddAssignment = () => {
    let pathName = constant.addAssignment + this.state.groupId;
    routeService.routePage(this.props, pathName);
  };

  handleSortBy = (event) => {
    let sortByVal = event.target.value;
    this.setState({ sortBy: sortByVal });
    this.loadCommunityAssignments(
      Number(this.state.groupId),
      sortByVal
    );
  };

  render() {
    const { classes, mediaQuery } = this.props;
    const subTitleWithIcon = classNames(
      classes.subHeader,
      classes.alignTextWithIcon
    );
    const subHeader = classNames(classes.posTop, classes.subHeader);
    const wrapIcon = classNames(classes.wrapIcon, classes.likesComments);
    const col3 = mediaQuery ? 3 : 12;
    const col9 = mediaQuery ? 9 : 12;
    const subHeaderX = classNames(classes.posTopX, classes.subHeader);

    return (
      <Fragment>
        <Backdrop className={classes.backdrop} open={this.state.loader}>
          <img src={EDWhatLogoIcon} height={50} alt="Logo" />
        </Backdrop>

        <SuccessInfo
          open={this.state.openInfo}
          textMsg={this.state.textMsg}
          handleClose={this.handleClose}
          infoType="success"
        ></SuccessInfo>

        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mediaQuery ? (
            <Card
              style={{
                backgroundColor: "#F9F9F9",
                marginLeft: 135,
                marginRight: 135,
                marginTop: 55,
              }}
            >
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={col3}>
                    <Card>
                      <CardContent>
                        <CommunityNavMenu
                          groupId={this.props.match.params.groupId}
                          selectedMenu="assignments"
                          isCommunityAdmin={
                            this.state.community.UserGroupStatus === "Owner"
                              ? true
                              : false
                          }
                          onApplyColorTheme={this.onApplyColorTheme}
                          handleFileSave={this.handleFileSave}
                          GroupName={this.state.community.GroupName}
                          onEditGroupName={this.onEditGroupName}
                          GroupDesc={this.state.community.GroupDesc}
                          onEditGroupDesc={this.onEditGroupDesc}
                          community = {this.state.community}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={col9}>
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ margin: "10px" }}>
                        <img
                          src={
                            this.state.community.CoverUrl
                              ? this.state.community.CoverUrl
                              : DefaultCoverPic
                          }
                          alt="img"
                          style={{
                            width: mediaQuery ? imageSizes.cover_pic.width : '100%',
                            height: mediaQuery ? imageSizes.cover_pic.height : '100%',
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} style={{ margin: "10px" }}>
                        <Typography className={subTitleWithIcon}>
                          <img
                            src={this.state.community.LogoUrl}
                            alt="img"
                            className={classes.leftIcon}
                            style={{
                              width: imageSizes.logo_icon.width,
                              height: imageSizes.logo_icon.height,
                            }}
                          />
                          <Typography className={classes.subHeaderSemiBold}>
                            {this.state.community.GroupName}
                            <Chip
                              label={CommonFunc.Capitalize(
                                this.state.community.CommunityType
                              )}
                              size="small"
                              className={classes.chipCard}
                            />
                          </Typography>
                        </Typography>
                      </Grid>
                      <Grid item xs={9} style={{ margin: "10px" }}>
                        <Typography>
                          <span
                            style={{
                              fontSize: 13,
                              color: "black",
                              fontFamily: "poppins",
                            }}
                          >
                            Sort By :
                          </span>
                          <FormControl
                            variant="outlined"
                            size="small"
                            style={{ marginLeft: 5 }}
                          >
                            <Select
                              labelId="demo-select-small"
                              id="demo-select-small"
                              value={this.state.sortBy}
                              onChange={this.handleSortBy}
                              style={{
                                backgroundColor: "white",
                                fontSize: 13,
                                fontFamily: "poppins",
                                height: 30,
                              }}
                              name="sortBy"
                            >
                              <MenuItem value="1">Date</MenuItem>
                              <MenuItem value="0">Title</MenuItem>
                            </Select>
                          </FormControl>
                        </Typography>
                      </Grid>
                      {this.state.community.UserGroupStatus === "Owner" && 
                      this.state.community.CategoryName === "Academic" && 
                      this.state.community.CommunityType === "private" &&
                          this.state.permissionLevel === "Create Topic" && (
                        <Grid item xs={2} style={{ margin: "10px" }}>
                          <Button
                            variant="contained"
                            className={classes.customButtonError}
                            size="small"
                            onClick={this.redirectToAddAssignment}
                            style={{ float: "right" }}
                          >
                            Add Assignment
                          </Button>
                        </Grid>
                      )}

                      {(this.state.community.CommunityType === "public" ||
                        (this.state.community.CommunityType === "private" &&
                          (this.state.community.UserGroupStatus === "Member" ||
                            this.state.community.UserGroupStatus ===
                              "Owner"))) && (
                        <Grid container spacing={2}>
                          {this.state.communityAssignments.map((assignment, row) => (
                            <Grid
                              item
                              xs={12}
                              key={assignment.ASSIGNMENT_ID}
                              style={{ margin: "10px", marginBottom: "0px" }}
                            >
                              <Card>
                                <CardHeader
                                  style={{
                                    cursor: "pointer",
                                    padding: "16px 16px 0px 16px",
                                  }}
                                  classes={{
                                    title: classes.title,
                                    subheader: classes.subTitle,
                                  }}
                                  onClick={(e) =>
                                    this.viewAssignmentDetails(
                                      assignment.ASSIGNMENT_ID,
                                      assignment.ASSIGNMENT_TITLE,
                                      e
                                    )
                                  }
                                  title={
                                    <span
                                      style={{
                                        color: this.state.colorData.title,
                                      }}
                                    >
                                      {assignment.ASSIGNMENT_TITLE}
                                    </span>
                                  }
                                  avatar={
                                    <IconButton
                                      aria-label="questions"
                                      style={{ marginTop: -32, padding: 0 }}
                                    >
                                    <img
                                      src={QuestionIcon}
                                      height={20}
                                      alt="QuestionIcon"
                                    />
                                    </IconButton>
                                  }
                                  subheader={
                                    <span
                                      style={{
                                        color: this.state.colorData.subtitle,
                                      }}
                                    >
                                      {"posted by " +
                                        assignment.ASSIGNMENT_UPDT_USER_NM +
                                        " " +
                                        assignment.ASSIGNMENT_UPDT_DTM +
                                        " ago"}
                                    </span>
                                  }
                                />
                                <CardContent style={{ marginLeft: 37 }}>
                                  <div>
                                    <Typography
                                      className={
                                        assignment.ASSIGNMENT_DESC.substring(0, 23) ===
                                        '<iframe frameborder="0"'
                                          ? subHeaderX
                                          : subHeader
                                      }
                                      gutterBottom
                                      onClick={(e) =>
                                        this.viewAssignmentDetails(
                                          assignment.ASSIGNMENT_ID,
                                          assignment.ASSIGNMENT_TITLE,
                                          e
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div
                                        style={{
                                          color: this.state.colorData.desc,
                                        }}
                                      >
                                        <span className="topics-ellipsis">
                                          {ReactHtmlParser(assignment.ASSIGNMENT_DESC)}
                                        </span>
                                      </div>
                                    </Typography>
                                    {assignment.ASSIGNMENT_IMG_URL && !this.isPdfFile(assignment.ASSIGNMENT_IMG_URL) && (
                                        <Typography
                                          style={{ cursor: "pointer" }}
                                        >
                                          <img
                                            src={assignment.ASSIGNMENT_IMG_URL}
                                            style={{
                                              width: "100%",
                                              padding: mediaQuery
                                                ? "10px 150px 10px 150px"
                                                : "10px 10px 10px 10px",
                                            }}
                                            alt="topicimg"
                                          />
                                        </Typography>
                                       )
                                      }
                                      {assignment.ASSIGNMENT_IMG_URL && this.isPdfFile(assignment.ASSIGNMENT_IMG_URL) && (
                                          <Typography>
                                            <Link href={assignment.ASSIGNMENT_IMG_URL} target="_blank">
                                              <PictureAsPdfIcon/>
                                            </Link>
                                          </Typography>
                                        )
                                      }
                                  </div>
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            ): (
              <Grid container spacing={0} style={{ marginTop: 90 }}>
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ marginTop: "10px" }}>
                      <img
                        src={
                          this.state.community.CoverUrl
                            ? this.state.community.CoverUrl
                            : DefaultCoverPic
                        }
                        alt="img"
                        style={{
                          width: "100%",
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: "20px" }}>
                      <Typography className={subTitleWithIcon}>
                        <img
                          src={this.state.community.LogoUrl}
                          alt="img"
                          className={classes.leftIcon}
                          style={{
                            width: imageSizes.logo_icon.width,
                            height: imageSizes.logo_icon.height,
                          }}
                        />
                        <Typography className={classes.subHeaderSemiBold}>
                          {this.state.community.GroupName}
                        </Typography>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: "20px" }}>
                      <Typography className={subTitleWithIcon}>
                        <Typography className={classes.subHeaderSemiBold}>
                          <Chip
                            label={CommonFunc.Capitalize(
                              this.state.community.CommunityType
                            )}
                            size="small"
                            className={classes.chipCardNoMargin}
                          />
                        </Typography>
                        <Button
                          style={{ marginLeft: 10 }}
                          variant="contained"
                          disabled={
                            this.state.community.UserGroupStatus === "" ||
                            this.state.community.UserGroupStatus === "Accept" ||
                            this.state.community.UserGroupStatus === "Member"
                              ? false
                              : true
                          }
                          className={
                            this.state.community.UserGroupStatus === "Owner" ||
                            this.state.community.UserGroupStatus === "Member"
                              ? classes.buttonOwnerMember
                              : this.state.community.UserGroupStatus ===
                                  "Requested" ||
                                this.state.community.UserGroupStatus ===
                                  "Accept"
                              ? classes.buttonAcceptRequested
                              : classes.buttonJoinDenied
                          }
                          size="small"
                          onClick={this.joinCommunityGroup}
                        >
                          <img
                            className={classes.leftIcon}
                            alt="member"
                            src={
                              this.state.community.UserGroupStatus === "Member"
                                ? MemberIcon
                                : this.state.community.UserGroupStatus ===
                                  "Owner"
                                ? OwnerIcon
                                : this.state.community.UserGroupStatus ===
                                  "Requested"
                                ? RequestedIcon
                                : this.state.community.UserGroupStatus ===
                                  "Accept"
                                ? AcceptedIcon
                                : this.state.community.UserGroupStatus ===
                                  "Denied"
                                ? DeniedIcon
                                : JoinIcon
                            }
                          />
                          {this.state.community.UserGroupStatus === ""
                            ? "Join"
                            : this.state.community.UserGroupStatus}
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid item xs={8} style={{ marginTop: "20px" }}>
                      <Typography>
                        <span style={{ fontSize: 11 }}>Sort By :</span>
                        <FormControl variant="outlined" size="small">
                          <Select
                            labelId="demo-select-small"
                            id="demo-select-small"
                            value={this.state.sortBy}
                            onChange={this.handleSortBy}
                            style={{
                              backgroundColor: "white",
                              fontSize: "0.7rem",
                            }}
                            name="sortBy"
                          >
                            <MenuItem value="1">Date</MenuItem>
                            <MenuItem value="0">Time</MenuItem>
                          </Select>
                        </FormControl>
                      </Typography>
                    </Grid>

                    {this.state.community.UserGroupStatus === "Owner" && 
                      this.state.community.CategoryName === "Academic" && 
                      this.state.community.CommunityType === "private" &&
                      this.state.permissionLevel === "Create Topic" && (
                        <Grid item xs={4} style={{ marginTop: "20px" }}>
                          <Button
                            variant="contained"
                            className={classes.customButtonError}
                            size="small"
                            onClick={this.redirectToAddAssignment}
                            style={{ float: "right" }}
                          >
                            Add Assignment
                          </Button>
                        </Grid>
                      )}
                  </Grid>

                  {(this.state.community.CommunityType === "public" ||
                    (this.state.community.CommunityType === "private" &&
                      (this.state.community.UserGroupStatus === "Member" ||
                        this.state.community.UserGroupStatus === "Owner"))) && (
                    <Grid container spacing={2} style={{ marginTop: "10px" }}>
                      {this.state.communityAssignments.map((assignment, row) => (
                        <Grid item xs={12} key={assignment.TOPIC_ID}>
                          <Card>
                            <CardHeader
                              style={{
                                cursor: "pointer",
                                padding: "16px 16px 0px 16px",
                              }}
                              classes={{
                                title: classes.title,
                                subheader: classes.subTitle,
                              }}
                              onClick={(e) =>
                                this.viewAssignmentDetails(
                                  assignment.ASSIGNMENT_ID,
                                  assignment.ASSIGNMENT_TITLE,
                                  e
                                )
                              }
                              title={
                                <span
                                  style={{ color: this.state.colorData.title }}
                                >
                                  {assignment.ASSIGNMENT_TITLE}
                                </span>
                              }
                              avatar={
                                <IconButton
                                  aria-label="questions"
                                  style={{ marginTop: -32, padding: 0 }}
                                >
                                  <img
                                    src={QuestionIcon}
                                    height={20}
                                    alt="QuestionIcon"
                                  />
                                </IconButton>
                              }
                              subheader={
                                <span
                                  style={{
                                    color: this.state.colorData.subtitle,
                                  }}
                                >
                                  {"posted by " +
                                    assignment.ASSIGNMENT_UPDT_USER_NM +
                                    " " +
                                    assignment.ASSIGNMENT_UPDT_DTM +
                                    " ago"}
                                </span>
                              }
                            />
                            <CardContent style={{ marginLeft: 37 }}>
                              <div>
                                <Typography
                                  className={
                                    assignment.ASSIGNMENT_DESC.substring(0, 23) ===
                                    '<iframe frameborder="0"'
                                      ? subHeaderX
                                      : subHeader
                                  }
                                  gutterBottom
                                  onClick={(e) =>
                                    this.viewAssignmentDetails(
                                      assignment.ASSIGNMENT_ID,
                                      assignment.ASSIGNMENT_TITLE,
                                      e
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div
                                    style={{ color: this.state.colorData.desc }}
                                  >
                                    {mediaQuery ? (
                                      <span className="topics-ellipsis">
                                        {ReactHtmlParser(assignment.ASSIGNMENT_DESC)}
                                      </span>
                                    ) : (
                                      <span className="topics-ellipsis">
                                        {assignment.ASSIGNMENT_DESC.indexOf(
                                          "https://www.youtube.com/embed/"
                                        ) > -1 ? (
                                          <span>
                                            {ReactHtmlParser(
                                              assignment.ASSIGNMENT_DESC.replace(
                                                'style="width:560px;height:315px;"',
                                                ""
                                              )
                                            )}
                                          </span>
                                        ) : (
                                          <span>
                                            {ReactHtmlParser(assignment.ASSIGNMENT_DESC)}
                                          </span>
                                        )}
                                      </span>
                                    )}
                                  </div>
                                </Typography>
                                {assignment.ASSIGNMENT_IMG_URL && !this.isPdfFile(assignment.ASSIGNMENT_IMG_URL) && (
                                    <Typography
                                      onClick={(e) =>
                                        this.viewAssignmentDetails(
                                          assignment.ASSIGNMENT_ID,
                                          assignment.ASSIGNMENT_TITLE,
                                          e
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={assignment.ASSIGNMENT_IMG_URL}
                                        style={{
                                          width: "100%",
                                          padding: mediaQuery
                                            ? "10px 150px 10px 150px"
                                            : "10px 10px 10px 10px",
                                        }}
                                        alt="topicimg"
                                      />
                                    </Typography>
                                   )
                                  }
                                  {assignment.ASSIGNMENT_IMG_URL && this.isPdfFile(assignment.ASSIGNMENT_IMG_URL) && (
                                      <Typography>
                                        <Link href={assignment.ASSIGNMENT_IMG_URL} target="_blank">
                                          <PictureAsPdfIcon/>
                                          {assignment.ASSIGNMENT_IMG_URL.split("/")[assignment.ASSIGNMENT_IMG_URL.split("/").length - 1]}
                                        </Link>
                                      </Typography>
                                    )
                                  }
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const communityData = state.communityReducer;
  return { communityData };
}

export default withRouter(
  withStyles(useStyles)(
    withMediaQuery("(min-width:600px)")(
      connect(mapStateToProps)(CommunityAssignments)
    )
  )
);
